import { FacebookAccountInfluencerV2, SocialAccountType } from '@anytag/graphql';
import { FacebookInfluencerProfile } from './schemaTypes';

export const formatInfluencerProfile = (infl: FacebookAccountInfluencerV2): FacebookInfluencerProfile => ({
  id: Number(infl.id),
  age: infl.age,
  name: infl.name,
  gender: infl.gender,
  country: infl.country,
  likes: infl.averageLikes,
  avatar: infl.avatar || '',
  status: infl.socialAccountStatus,
  isBrandAccount: infl.isBrandAccount,
  socialAccountId: infl.socialAccountId,
  followers: infl.socialAccountFollowers,
  socialAccountType: SocialAccountType.FACEBOOK,
  engagementRate: infl.socialAccountEngagementRate,
  posts:
    infl.popularPosts?.map(({ postId, thumbNail, caption }) => ({
      thumbNail,
      id: postId,
      influencerId: Number(infl.id),
      caption
    })) || []
});
